import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { BaleInfo } from "./bale-info.entity";
import { getConnection, getManager, QueryRunner, Repository } from "typeorm";
import { BaleItems } from "./bale-items.entity";
import appSettings from "apps/services/config";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { BaleDateReq, BaleInfoReq, BaleQtyUpdateReq, BaleReportReq, BaleReq, TabNameReq } from "@gtpl/shared-models/raw-material-procurement";
import { BaleStatusEnum, BaleTypeEnum } from "@gtpl/shared-models/common-models";
import { GrnItems } from "../raw-material-grn/raw-material-grn-items.entity";
import { WorkOrderService } from "../work-order-generation/work-order.service";
import { ProdlogService } from "libs/shared-services/production/src/lib/prod-log.service";
import { WorkOrderDto } from "../work-order-generation/dto/work-order.dto";
import { WorkOrderItemsDto } from "../work-order-generation/dto/work-order-items.dto";
import { ActualBaleQtyLogs } from "./act-bale-qty-entity";
import { WarehouseDashboardService } from '@gtpl/shared-services/analytics';

@Injectable()
export class BaleService {
  constructor(
    @InjectRepository(BaleInfo)
    private baleRepo: Repository<BaleInfo>,
    @InjectRepository(BaleItems)
    private baleItemsRepo: Repository<BaleItems>,
    @InjectRepository(ActualBaleQtyLogs)
    private actualBaleQtyLogsRepo: Repository<ActualBaleQtyLogs>,
    private workOrderService:WorkOrderService,
    private prodLogservice:ProdlogService,
    private analyticsService : WarehouseDashboardService
  
  ){}

  async getRmInwardInfo(req:BaleInfoReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let rmInwardQry = ` SELECT i.indent_code as inwardNumber,g.grn_date as voucherDate,g.voucher_number as voucherNumber,gi.quality,gi.quantity,s.name as agent,p.name as variant,gi.quantity - gi.bale_qty as remainingQty,gi.quantity - gi.bale_qty as baleQty,gi.grn_item_id as grnItemId,
      gi.farmer as agentId,g.plant_id as plantId,gi.product as variantId,'Partial' as reportingType,ii.package_type as packageType,i.rm_inward_type as inwardType,gi.price as inwardPrice
      FROM ${appSettings.rm_procure_db} .grn_items gi
      LEFT JOIN  ${appSettings.rm_procure_db} .grn g ON g.grn_id = gi.grn_id
      LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id
      LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = gi.farmer
      LEFT JOIN ${appSettings.masters_db} .products p ON p.product_id = gi.product
      LEFT JOIN ${appSettings.rm_procure_db} .indent_items ii ON ii.indent_item_id = gi.indent_item_id
      WHERE (gi.reporting_type IS NULL OR gi.reporting_type = 'Partial') `
      if(req.inwardNumber != undefined){
        rmInwardQry += ` AND i.indent_code IN (${req.inwardNumber.map(item => `'${item}'`).join(',')})`
      }
      if(req.voucherNumber != undefined){
        rmInwardQry += ` AND g.voucher_number IN (${req.voucherNumber.map(item => `'${item}'`).join(',')})`
      }
      if(req.agent != undefined){
        rmInwardQry += ` AND gi.farmer IN (${req.agent})`
      }
      rmInwardQry += ` ORDER BY g.created_at DESC`
      const rmInwardInfo = await manager.query(rmInwardQry)

      if(rmInwardInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',rmInwardInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async createBale(req:BaleReq):Promise<CommonResponse>{
    console.log(req,"reqqqqqqqqqqqqqqqqqqqqqqqqqqqqq")
    const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();
    try{
      await transManager.startTransaction()

      const getRefNoQry = `SELECT MAX(ref_no) as refNo FROM ${appSettings.rm_procure_db} .bale_info`
      const refNoInfo = await transManager.query(getRefNoQry)
      const refNo = refNoInfo.length > 0 ? Number(refNoInfo[0].refNo) + 1 : 1

      if(req.type === BaleTypeEnum.Export){
        const productQuery=`SELECT name FROM ${appSettings.masters_db} .products WHERE product_id = ${req.variantId}`
        const productData=await getManager().query(productQuery)
        const prodName = productData.length > 0 ? productData[0].name : null;
        if(prodName){
          const skuQuery=`SELECT sku_code_id FROM ${appSettings.masters_db} .sku_codes WHERE short_code = '${prodName}'`
          const skuData=await getManager().query(skuQuery)
          if(skuData.length > 0){
            // sku exists, proceed
          }else{
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false, 0, 'No Product Found For this Variant');
          }
        }else{
          await transManager.rollbackTransaction()
          await transManager.release()
            return new CommonResponse(false, 0, 'Variant Not Found');
        }
      }
      const baleObj = new BaleInfo()
      baleObj.baleDate = req.date
      baleObj.quantity = req.totQty
      baleObj.type = req.type
      baleObj.status = BaleStatusEnum.OPEN
      baleObj.baleNo = `${req.type == BaleTypeEnum.Export ? 'BEXP' : 'BPRO'}-${String(refNo).padStart(3, '0')}`;
      baleObj.createdUser = req.createdUser
      baleObj.refNo = refNo
      baleObj.actualbaleQty = req.actualBaleQty
      baleObj.variantId = req.variantId
      baleObj.plantId = req.plantId
      baleObj.quality = req.quality
      baleObj.tareQty = Number(req.tareWeight)
      baleObj.grossQty = req.grossQty

      const baleItems = []
      for(const rec of req.baleItemsInfo){
        const itemObj = new BaleItems()
        itemObj.agentId = rec.agentId
        itemObj.createdUser = req.createdUser
        itemObj.inwardItemId = rec.inwardItemId
        itemObj.quality = rec.quality
        itemObj.voucherNo = rec.voucherno
        itemObj.quantity = rec.baleQty
        itemObj.variantId = rec.variantId
        itemObj.plantId = req.plantId
        baleItems.push(itemObj)
      }
      baleObj.baleItemsInfo = baleItems
      const save = await transManager.manager.getRepository(BaleInfo).save(baleObj)
      if(save){
        const updateFlag = new Set<boolean>()
        for(const rec of req.baleItemsInfo){
          const updateBaleQty = await transManager.manager.getRepository(GrnItems).update({grnItemId : rec.inwardItemId},{baleQty:() => `bale_qty + ${rec.baleQty}`,reportingType:rec.reportingType})
          if(updateBaleQty.affected){
            updateFlag.add(true)
          }else{
            updateFlag.add(false)
          }
        }
        if (req.type === BaleTypeEnum.Export) {

          const woReq = new WorkOrderDto();

          woReq.workOrderDate = req.date;        
          woReq.remarks = null;                
          woReq.plantId = req.plantId;
          woReq.createdUser = req.createdUser;
          woReq.baleType = req.type;
          woReq.workOrderItems = [];

          const woItem = new WorkOrderItemsDto();

woItem.baleId = save.id;
woItem.quantity = req.actualBaleQty;   // ✅ FIXED
woItem.createdUser = req.createdUser;

woReq.workOrderItems.push(woItem);

          // for (let i = 0; i < save.baleItemsInfo.length; i++) {
          //   const baleItem = save.baleItemsInfo[i];   
          //   const reqItem = req.baleItemsInfo[i];     

          //   const woItem = new WorkOrderItemsDto();

          //   woItem.baleId = save.id;                 
          //   woItem.quantity = req.actualBaleQty;       
          //   woItem.createdUser = req.createdUser;

          //   woReq.workOrderItems.push(woItem);
          // }

          const woRes = await this.workOrderService.createWorkOrder(woReq,transManager);

          if (!woRes.status) {
            await transManager.rollbackTransaction()
          await transManager.release()
            return new CommonResponse(false, 0, 'Work order creation failed for export bale');
          }
        }
        if(!(updateFlag.has(false))){
          req.baleId = save.id
          const baleAmtInfoSave = await this.analyticsService.createBaleAmtInfo(req)
          if(!baleAmtInfoSave.status){
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false,0,baleAmtInfoSave.internalMessage)
          }else{
            await transManager.commitTransaction()
            await transManager.release()
            return new CommonResponse(true,1,'Bale Created Successfully')
          }
        }else{
          await transManager.rollbackTransaction()
          await transManager.release()
          return new CommonResponse(false,0,'Something went wrong in updating Bale Qty')
        }
      }else{
        await transManager.rollbackTransaction()
        await transManager.release()
        return new CommonResponse(false,0,'Something went wrong in generating Bale')
      }
    }catch(err){
      await transManager.rollbackTransaction()
      await transManager.release()
      return new CommonResponse(false,0,'Something went wrong',err)
    }
  }

 async updateActualBaleQty(req: BaleQtyUpdateReq): Promise<CommonResponse> {
  const manager = getManager();
  
  return await manager.transaction(async (transactionalEntityManager) => {
    try {
      if (Number(req.actualBaleQty) <= 0) {
        return new CommonResponse(false, 0, 'Actual Bale Qty must be greater than 0');
      }
      
      const currentBaleInfo = await transactionalEntityManager.findOne(BaleInfo, {
        where: { id: req.baleId, baleNo: req.baleNumber }
      });
      console.log(currentBaleInfo,'currentBaleInfo')
      if (!currentBaleInfo) {
        return new CommonResponse(false, 0, 'Bale not found');
      }
      
      const oldQuantity = currentBaleInfo.actualbaleQty;
      const newQuantity = Number(req.actualBaleQty);
      
      const result = await transactionalEntityManager.update(
        BaleInfo,
        { id: req.baleId, baleNo: req.baleNumber },
        { actualbaleQty: newQuantity }
      );
      
      if (result.affected === 0) {
        return new CommonResponse(false, 0, 'Bale not found');
      }
      
      const logsData = new ActualBaleQtyLogs();
      logsData.baleId = currentBaleInfo.id;
      logsData.oldQuantity = oldQuantity;
      logsData.newQuantity = newQuantity;
      logsData.createdUser = currentBaleInfo.createdUser;
      logsData.createdAt = new Date(); 
      logsData.updatedAt = new Date(); 
      logsData.date = req.date
        ? new Date(new Date(req.date).toISOString().split('T')[0])
        : null;      
      await transactionalEntityManager.save(ActualBaleQtyLogs, logsData);
      
      return new CommonResponse(true, 1, 'Bale Qty updated successfully');
      
    } catch (err) {
      console.error('Error in updateActualBaleQty:', err);
      throw err; 
    }
  });
  }

  async getBaleInfo(req:BaleInfoReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry = `SELECT b.bale_no as baleNumber,b.id as baleId,b.status,b.bale_date as baleDate,b.type,bi.agent_id as agentId,bi.quality,bi.quantity as baleQty,bi.voucher_no as voucherNumber,s.name as agent,i.indent_code as inwardNumber,p.name as variant,
      ii.package_type as packageType,b.actual_bale_qty as actualBaleQty,b.tare_qty as tareWeight,b.gross_qty as grossWeight,pro.name as baleVariant,b.quality as baleQuality
      FROM ${appSettings.rm_procure_db} .bale_items bi
      LEFT JOIN ${appSettings.rm_procure_db} .bale_info b ON b.id = bi.bale_id
      LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = bi.agent_id
      LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.grn_item_id = bi.inward_item_id
      LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id
      LEFT JOIN ${appSettings.masters_db} .products p ON p.product_id = bi.variant_id
      LEFT JOIN ${appSettings.masters_db} .products pro ON pro.product_id = b.variant_id
      LEFT JOIN ${appSettings.rm_procure_db} .indent_items ii ON ii.indent_item_id = gi.indent_item_id
      WHERE bi.id > 0
      `
      if(req.inwardNumber != undefined){
        getQry += ` AND i.indent_code IN (${req.inwardNumber.map(item => `'${item}'`).join(',')})`
      }
      if(req.voucherNumber != undefined){
        getQry += ` AND bi.voucher_no IN (${req.voucherNumber.map(item => `'${item}'`).join(',')})`
      }
      if(req.agent != undefined){
        getQry += ` AND bi.agent_id IN (${req.agent})`
      }
      if(req.baleNumber != undefined){
        getQry += ` AND b.bale_no IN (${req.baleNumber.map(item => `'${item}'`).join(',')})`
      }
      getQry += ` ORDER BY b.created_at DESC`
      const baleInfo = await manager.query(getQry)
      if(baleInfo.length > 0){
        const baleInfoMap = new Map<string,any>()
        for(const rec of baleInfo){
          if(!(baleInfoMap.has(rec.baleNumber))){
            baleInfoMap.set(rec.baleNumber,{baleNumber:rec.baleNumber,baleDate:rec.baleDate,type:rec.type,actualBaleQty:rec.actualBaleQty,baleVariant:rec.baleVariant,baleQuality:rec.baleQuality,tareWeight:rec.tareWeight,grossWeight:rec.grossWeight,status:rec.status,baleId:rec.baleId,itemsInfo:[]})
          }
          baleInfoMap.get(rec.baleNumber).itemsInfo.push({agentId:rec.agentId,quality:rec.quality,baleQty:rec.baleQty,voucherNumber:rec.voucherNumber,agent:rec.agent,inwardNumber:rec.inwardNumber,variant:rec.variant,packageType:rec.packageType})
        }

        return new CommonResponse(true,1,'Data retrieved',Array.from(baleInfoMap.values()))
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
}

  async getInwardNumberDropDownInfo(req?:TabNameReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry
      if(req.tabName == 'Open'){
        getQry = `SELECT i.indent_code as inwardNumber FROM ${appSettings.rm_procure_db} .grn_items gi
        LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id WHERE gi.quantity - gi.bale_qty > 0 GROUP BY i.indent_code`
      }else{
        getQry = `SELECT i.indent_code as inwardNumber FROM ${appSettings.rm_procure_db} .bale_items bi LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.grn_item_id = bi.inward_item_id 
        LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id GROUP BY i.indent_code`
      }
      const inwardNumberInfo = await manager.query(getQry)
      if(inwardNumberInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',inwardNumberInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getVoucherNumberDropDownInfo(req:TabNameReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry
      if(req.tabName == 'Open'){
        getQry = `SELECT g.voucher_number as voucherNumber FROM ${appSettings.rm_procure_db} .grn_items gi
        LEFT JOIN ${appSettings.rm_procure_db} .grn g ON g.grn_id = gi.grn_id WHERE gi.quantity - gi.bale_qty > 0 GROUP BY g.voucher_number`
      }else{
        getQry = `SELECT bi.voucher_no as voucherNumber FROM ${appSettings.rm_procure_db} .bale_items bi  GROUP BY bi.voucher_no`
      }
      const voucherNumberInfo = await manager.query(getQry)
      if(voucherNumberInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',voucherNumberInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getAgentDropDownInfo(req:TabNameReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry
      if(req.tabName == 'Open'){
        getQry = `SELECT s.name as agent,gi.farmer as agentId FROM ${appSettings.rm_procure_db} .grn_items gi
        LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = gi.farmer WHERE gi.quantity - gi.bale_qty > 0 GROUP BY gi.farmer`
      }else{
        getQry = `SELECT s.name as agent,bi.agent_id as agentId FROM ${appSettings.rm_procure_db} .bale_items bi LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = bi.agent_id
        GROUP BY bi.agent_id`
      }
      const agentInfo = await manager.query(getQry)
      if(agentInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',agentInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getBaleNumberDropDownInfo():Promise<CommonResponse>{
    const manager = getManager()
    try{
      const getQry = `SELECT bale_no as baleNumber FROM ${appSettings.rm_procure_db} .bale_info`
      const baleNumberInfo = await manager.query(getQry)

      if(baleNumberInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',baleNumberInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

async getBaleReportInfo(req: BaleInfoReq): Promise<CommonResponse> {
  const manager = getManager()

  try {

    let getQry = `
      SELECT 
        b.bale_no as baleNumber,
        b.id as baleId,
        b.status,
        b.bale_date as baleDate,
        b.type,
        bi.agent_id as agentId,
        bi.quality,
        bi.quantity as baleQty,
        bi.voucher_no as voucherNumber,
        s.name as agent,
        i.indent_code as inwardNumber,
        p.name as variant,
        ii.package_type as packageType,
        b.actual_bale_qty as actualBaleQty,
        b.tare_qty as tareWeight,
        b.gross_qty as grossWeight,
        pro.name as baleVariant,
        b.quality as baleQuality,
        b.status as baleStatus,

        (
          SELECT SUM(quantity)
          FROM ${appSettings.rm_procure_db}.work_order_items woi
          WHERE woi.bale_id = b.id
        ) as workOrderQty,

        (
          SELECT JSON_ARRAYAGG(
            JSON_OBJECT(
              'oldQuantity', abql.old_quantity,
              'createdDate', abql.created_at
            )
          )
          FROM ${appSettings.rm_procure_db}.act_bale_qty_logs abql
          WHERE abql.bale_id = b.id
        ) as baleQtyLogs

      FROM ${appSettings.rm_procure_db}.bale_items bi

      LEFT JOIN ${appSettings.rm_procure_db}.bale_info b 
        ON b.id = bi.bale_id

      LEFT JOIN ${appSettings.masters_db}.suppliers s 
        ON s.supplier_id = bi.agent_id

      LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi 
        ON gi.grn_item_id = bi.inward_item_id

      LEFT JOIN ${appSettings.rm_procure_db}.indent i 
        ON i.indent_id = gi.indent_id

      LEFT JOIN ${appSettings.masters_db}.products p 
        ON p.product_id = bi.variant_id

      LEFT JOIN ${appSettings.masters_db}.products pro 
        ON pro.product_id = b.variant_id

      LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii 
        ON ii.indent_item_id = gi.indent_item_id

      WHERE bi.id > 0
    `

    if (req.inwardNumber?.length > 0) {
      getQry += `
        AND i.indent_code IN (
          ${req.inwardNumber.map(item => `'${item}'`).join(',')}
        )
      `
    }

    if (req.voucherNumber?.length > 0) {
      getQry += `
        AND bi.voucher_no IN (
          ${req.voucherNumber.map(item => `'${item}'`).join(',')}
        )
      `
    }

  

    if (req.baleNumber?.length > 0) {
      getQry += `
        AND b.bale_no IN (
          ${req.baleNumber.map(item => `'${item}'`).join(',')}
        )
      `
    }

    if(req.fromDate && req.toDate){
      getQry += `
        AND b.bale_date BETWEEN '${req.fromDate}' AND '${req.toDate}'
      `
    }
    if(req.variant){
      getQry += `
        AND b.variant_id = ${req.variant}
      `
    }

    getQry += ` ORDER BY b.created_at DESC`

    const baleInfo = await manager.query(getQry)

    if (baleInfo.length > 0) {

      const baleInfoMap = new Map<string, any>()

      for (const rec of baleInfo) {

        if (!(baleInfoMap.has(rec.baleNumber))) {

          baleInfoMap.set(rec.baleNumber, {
            baleNumber: rec.baleNumber,
            baleDate: rec.baleDate,
            type: rec.type,
            actualBaleQty: rec.actualBaleQty,
            baleVariant: rec.baleVariant,
            baleQuality: rec.baleQuality,
            tareWeight: rec.tareWeight,
            grossWeight: rec.grossWeight,
            status: rec.status,
            baleId: rec.baleId,
            workOrderQty: rec.workOrderQty,

            baleQtyLogs: rec.baleQtyLogs
              ? JSON.parse(rec.baleQtyLogs).slice(0, 2)
              : [],

            itemsInfo: []
          })
        }

        baleInfoMap.get(rec.baleNumber).itemsInfo.push({
          agentId: rec.agentId,
          quality: rec.quality,
          baleQty: rec.baleQty,
          voucherNumber: rec.voucherNumber,
          agent: rec.agent,
          inwardNumber: rec.inwardNumber,
          variant: rec.variant,
          packageType: rec.packageType
        })
      }

      return new CommonResponse(
        true,
        1,
        'Data retrieved',
        Array.from(baleInfoMap.values())
      )

    } else {
      return new CommonResponse(false, 0, 'No data found')
    }

  } catch (err) {
    throw err
  }
}

async getLotAgainstBaleData(req?:BaleDateReq):Promise<CommonResponse>{
  const manager = getManager()
  try{
    let getQry = `SELECT b.id AS baleId,b.bale_no AS baleNo,b.bale_date AS baleDate,woi.lot_number AS lotNumber,b.variant_id FROM bale_info b
    LEFT JOIN work_order_items woi ON woi.bale_id=b.id
    LEFT JOIN demo_erpx_dev_masters.products p ON p.product_id=b.variant_id
    WHERE lot_number IS NOT NULL AND woi.is_stock_in=0`
    if(req.baleFromDate && req.baleToDate){
      getQry += ` AND DATE(b.bale_date) BETWEEN '${req.baleFromDate}' AND '${req.baleToDate}'`
    }
    if(req.variantName){
      getQry += ` AND p.name = '${req.variantName}'`
    }
    const baleData = await manager.query(getQry)
    if(baleData.length > 0){
      return new CommonResponse(true,1,'Data retrieved',baleData)
    }
    else{
      return new CommonResponse(false,0,'No data found')
    }
  }catch(err){
    throw err
  }
}

async getLotDataAgainstBaleDate(req?:BaleDateReq):Promise<CommonResponse>{
  const manager = getManager()
  try{
    let getQry = `SELECT b.id AS baleId,b.bale_no AS baleNo,b.bale_date AS baleDate,woi.lot_number AS lotNumber,b.quality,b.variant_id as variantId,p.name,woi.quantity,pi.year FROM bale_info b
    LEFT JOIN work_order_items woi ON woi.bale_id=b.id
    LEFT JOIN ${appSettings.production_db}.production_inventory pi on pi.lot_number=woi.lot_number and pi.entry_type='OUT' and pi.operation='GRN' 
    LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=b.variant_id
    WHERE woi.lot_number IS NOT NULL AND woi.is_stock_in=0`
    if(req.baleFromDate && req.baleToDate){
      getQry += ` AND DATE(b.bale_date) BETWEEN '${req.baleFromDate}' AND '${req.baleToDate}'`
    }
    if(req.fromLot && req.toLot){
      getQry += ` AND woi.lot_number BETWEEN '${req.fromLot}' AND '${req.toLot}'`
    }
        if(req.variantName){
      getQry += ` AND p.name = '${req.variantName}'`
    }
    const baleData = await manager.query(getQry)
    if(baleData.length > 0){
      return new CommonResponse(true,1,'Data retrieved',baleData)
    }
    else{
      return new CommonResponse(false,0,'No data found')
    }
  }catch(err){
    throw err
  }
}

async getBaleReport(req?:BaleReportReq):Promise<CommonResponse>{
  const manager = getManager()
  try{
    let getQry = `SELECT bai.bale_qty AS baleQuantity,bai.price as balePrice,b.bale_no AS baleNo,b.status,b.work_order_qty AS workOrderQty,b.quality AS baleQuality,b.type AS baleType,
ii.expected_qty AS inwardQuantity,ii.quality AS inwardQuality,i.indent_code AS inwardNo,
bp.name AS baleVariant,ip.name AS inwardVariant,s.name AS vendor,gi.price AS inwardPricePerKg,b.variant_id
FROM ${appSettings.analytics_db}.bale_amt_info bai
LEFT JOIN ${appSettings.rm_procure_db}.bale_info b ON b.id=bai.bale_id
LEFT JOIN ${appSettings.rm_procure_db}.bale_items bi ON bi.bale_id=b.id
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id=bi.inward_item_id
LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id=gi.indent_item_id
LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id=gi.indent_id
LEFT JOIN ${appSettings.rm_procure_db}.work_order_items woi ON woi.bale_id=b.id AND b.type='EXPORT'
LEFT JOIN ${appSettings.masters_db}.products bp ON bp.product_id=b.variant_id
LEFT JOIN ${appSettings.masters_db}.products ip ON ip.product_id=ii.product
LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=ii.farmer
WHERE ((b.type = 'EXPORT' AND NOT EXISTS ( SELECT 1 FROM ${appSettings.warehouse_db}.reporting r WHERE r.lot_code = woi.lot_number))
    OR (b.type <> 'EXPORT'AND (b.quantity - b.work_order_qty) > 0 ))`
        if(req.baleFromDate && req.baleToDate){
      getQry += ` AND DATE(b.bale_date) BETWEEN '${req.baleFromDate}' AND '${req.baleToDate}'`
    }
    if(req.baleVariantId){
      getQry += ` AND b.variant_id=${req.baleVariantId}`
    }
    if(req.baleNo){
        getQry += ` AND b.bale_no='${req.baleNo}'`
    }
        if(req.baleQuality){
        getQry += ` AND b.quality='${req.baleQuality}'`
    }

    const result = await manager.query(getQry);
    let report = {};
            result.forEach(row => {
            const {
                baleNo, baleQuantity, balePrice, status, workOrderQty, baleQuality, baleType,
                inwardQuantity, inwardQuality, inwardNo, inwardPricePerKg,
                baleVariant, inwardVariant, vendor
            } = row;

            if (!report[baleNo]) {
                report[baleNo] = {
                    baleNo,
                    baleQuantity,
                    balePrice,
                    status,
                    workOrderQty,
                    baleQuality,
                    baleType,
                    baleVariant,
                    totalAmount: 0,
                    totalNoOfCases: 0,
                    totalNetWeight: 0,
                    items: []
                };
            }

            report[baleNo].items.push({
                inwardQuantity,
                inwardQuality,
                inwardNo,
                inwardPricePerKg,
                inwardVariant,
                vendor,
            });
        });

        const reportArray = Object.values(report);
    if(reportArray.length > 0){
      return new CommonResponse(true,1,'Data retrieved',reportArray)
    }else{
      return new CommonResponse(false,0,'No data found')
    }
  }catch(err){
    throw err
  }
}

async getBaleNoForBaleReport():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT b.bale_no as baleNo FROM ${appSettings.analytics_db}.bale_amt_info bai 
LEFT JOIN ${appSettings.rm_procure_db}.bale_info b ON b.id=bai.bale_id
LEFT JOIN ${appSettings.rm_procure_db}.work_order_items woi ON woi.bale_id=b.id AND b.type='EXPORT'
WHERE ((b.type = 'EXPORT' AND NOT EXISTS 
( SELECT 1 FROM ${appSettings.warehouse_db}.reporting r WHERE r.lot_code = woi.lot_number))
    OR (b.type <> 'EXPORT'AND (b.quantity - b.work_order_qty) > 0 ))`

 let data=  await manager.query(query) 
 if(data?.length>0){
  return new CommonResponse(true,1,"Data Retrieved",data)
 }else{
  return new CommonResponse(false,0,'No Data Found',[])
 }
}

async getBaleVariantForBaleReport():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT b.variant_id as variantId,bp.name FROM ${appSettings.analytics_db}.bale_amt_info bai 
LEFT JOIN ${appSettings.rm_procure_db}.bale_info b ON b.id=bai.bale_id
LEFT JOIN ${appSettings.rm_procure_db}.work_order_items woi ON woi.bale_id=b.id AND b.type='EXPORT'
LEFT JOIN ${appSettings.masters_db}.products bp ON bp.product_id=b.variant_id
WHERE ((b.type = 'EXPORT' AND NOT EXISTS 
( SELECT 1 FROM ${appSettings.warehouse_db}.reporting r WHERE r.lot_code = woi.lot_number))
    OR (b.type <> 'EXPORT'AND (b.quantity - b.work_order_qty) > 0 )) GROUP BY b.variant_id`

 let data=  await manager.query(query) 
 if(data?.length>0){
  return new CommonResponse(true,1,"Data Retrieved",data)
 }else{
  return new CommonResponse(false,0,'No Data Found',[])
 }
}

async getBaleQualityForBaleReport():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT b.quality FROM ${appSettings.analytics_db}.bale_amt_info bai 
LEFT JOIN ${appSettings.rm_procure_db}.bale_info b ON b.id=bai.bale_id
LEFT JOIN ${appSettings.rm_procure_db}.work_order_items woi ON woi.bale_id=b.id AND b.type='EXPORT'
WHERE b.quality!='NULL' AND ((b.type = 'EXPORT' AND NOT EXISTS 
( SELECT 1 FROM ${appSettings.warehouse_db}.reporting r WHERE r.lot_code = woi.lot_number))
    OR (b.type <> 'EXPORT'AND (b.quantity - b.work_order_qty) > 0 )) GROUP BY b.quality`

 let data=  await manager.query(query) 
 if(data?.length>0){
  return new CommonResponse(true,1,"Data Retrieved",data)
 }else{
  return new CommonResponse(false,0,'No Data Found',[])
 }
}

async getinwardDetailsInBaleReport(req?:BaleReportReq):Promise<CommonResponse>{
  const manager = getManager()
  try{
    let getQry = `SELECT i.indent_id,i.indent_code AS inwardCode,i.rm_inward_type AS inwardType,ii.farmer,ii.product,
ii.expected_qty AS inwardQty,ii.quality,gi.price AS inwardPrice,gi.bale_qty AS baleQty,ip.name AS inwardVariant,
s.name AS vendor,(gi.quantity-gi.bale_qty) AS remainingQty,((gi.quantity-gi.bale_qty)*gi.price) AS remainingAmt,
(gi.quantity*gi.price) as totalAmt
FROM ${appSettings.rm_procure_db}.indent i
LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_id=i.indent_id
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.indent_item_id=ii.indent_item_id
LEFT JOIN ${appSettings.masters_db}.products ip ON ip.product_id=ii.product
LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=ii.farmer
WHERE gi.quantity-gi.bale_qty>0`
    if(req.inwardVariantId){
      getQry += ` AND ii.product=${req.inwardVariantId}`
    }
    if(req.inwardNo){
        getQry += ` AND i.indent_code='${req.inwardNo}'`
    }
        if(req.inwardQuality){
        getQry += ` AND ii.quality='${req.inwardQuality}'`
    }
    if(req.inwardVendor){
        getQry += ` AND s.name='${req.inwardVendor}'`
    }

    const result = await manager.query(getQry);
                const formatNumber = (value: any) => {
                if (value === null || value === undefined) return value;
                return Number(parseFloat(value).toFixed(3));
            };
    let report = {};
            result.forEach(row => {
            const {
                inwardCode, inwardType, inwardQty, quality, inwardPrice, baleQty, inwardVariant,
                vendor, remainingQty, remainingAmt,totalAmt
            } = row;

            if (!report[inwardCode]) {
                report[inwardCode] = {
                    inwardCode,
                    inwardType,  
                    items: []
                };
            }

          report[inwardCode].items.push({
              vendor,
              remainingQty: formatNumber(remainingQty),
              remainingAmt: formatNumber(remainingAmt),
              inwardVariant,
              inwardQty: formatNumber(inwardQty),
              quality,
              inwardPrice: formatNumber(inwardPrice),
              baleQty: formatNumber(baleQty),
              totalAmt: formatNumber(totalAmt)
          });
        });

        const reportArray = Object.values(report);
    if(reportArray.length > 0){
      return new CommonResponse(true,1,'Data retrieved',reportArray)
    }else{
      return new CommonResponse(false,0,'No data found')
    }
  }catch(err){
    throw err
  }
}

async getinwardQualityForBaleReport():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT ii.quality FROM ${appSettings.rm_procure_db}.indent_items ii
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.indent_item_id=ii.indent_item_id
WHERE  gi.quantity-gi.bale_qty>0 
GROUP BY ii.quality`

 let data=  await manager.query(query) 
 if(data?.length>0){
  return new CommonResponse(true,1,"Data Retrieved",data)
 }else{
  return new CommonResponse(false,0,'No Data Found',[])
 }
}

async getInwardVariantForBaleReport():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT ii.product AS variantId,ip.name AS inwardVariant FROM ${appSettings.rm_procure_db}.indent_items ii
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.indent_item_id=ii.indent_item_id
LEFT JOIN ${appSettings.masters_db}.products ip ON ip.product_id=ii.product
WHERE gi.quantity-gi.bale_qty>0
GROUP BY ii.product`
 let data=  await manager.query(query) 
 if(data?.length>0){
  return new CommonResponse(true,1,"Data Retrieved",data)
 }else{
  return new CommonResponse(false,0,'No Data Found',[])
 }
}

async getInwardVendorForBaleReport():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT ii.farmer AS vendorId,s.name AS vendor  FROM ${appSettings.rm_procure_db}.indent_items ii
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.indent_item_id=ii.indent_item_id
LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=ii.farmer
WHERE gi.quantity-gi.bale_qty>0
GROUP BY ii.farmer`

 let data=  await manager.query(query) 
 if(data?.length>0){
  return new CommonResponse(true,1,"Data Retrieved",data)
 }else{
  return new CommonResponse(false,0,'No Data Found',[])
 }
}

async getInwardNoForBaleReport():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT i.indent_code AS inwardNo FROM ${appSettings.rm_procure_db}.indent i
LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_id=i.indent_id
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.indent_item_id=ii.indent_item_id
WHERE gi.quantity-gi.bale_qty>0
GROUP BY i.indent_code`

 let data=  await manager.query(query) 
 if(data?.length>0){
  return new CommonResponse(true,1,"Data Retrieved",data)
 }else{
  return new CommonResponse(false,0,'No Data Found',[])
 }
}

}